import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { useNavigate } from 'react-router-dom';
import StatisticsPage from './components/StatisticsPage';

const StatisticsPageContainer: React.FC = (): React.ReactElement => {
  const user = useSelector((state: RootState) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    // Проверяем, что пользователь авторизован и имеет права администратора
    if (!user) {
      navigate('/auth', { replace: true });
      return;
    }

    // Проверяем роль пользователя (3 - Admin, 4 - SuperAdmin)
    if (user.role_id < 3) {
      navigate('/dialogs', { replace: true });
      return;
    }
  }, [user, navigate]);

  if (!user || user.role_id < 3) {
    return <div>Загрузка...</div>;
  }

  return <StatisticsPage />;
};

export default StatisticsPageContainer; 